module.exports = __webpack_public_path__ + "img/day19.a9c69a2f.jpeg";